import React from 'react';
import CacheBuster from 'react-cache-buster';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import {store, persistor, history} from './redux/index';
import 'bootstrap/dist/css/bootstrap.css';
import * as serviceWorker from './serviceWorker';
import './global'

const RouteApp = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <CacheBuster
        currentVersion={process.env.REACT_APP_BUILD_NUMBER}
        isEnabled={true}
      >
      <App history={history} />
      </CacheBuster>
    </PersistGate>
  </Provider>
);
ReactDOM.render(
  <React.StrictMode>
    <RouteApp />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();